import React, { useState, useEffect } from 'react'
import { Card, CardContent, Grid, Typography, Button, Box, TextField, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Snackbar, Alert, Slide, Icon, IconButton } from '@mui/material'
import imageMapResize from 'image-map-resizer'
import dateFormat, { masks } from "dateformat";
import CircularProgress from '@mui/material/CircularProgress';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import Fab from '@mui/material/Fab';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import Tooltip from '@mui/material/Tooltip';
//firebase
import { collection, query, orderBy, onSnapshot, getDocs, where, addDoc, doc, getDoc } from "firebase/firestore"
import { app, database, storage } from '../firebaseConfig'
//composant
import CarteComponent from '../components/CarteComponent';
import PersonneComponent from '../components/PersonneComponent';
import SpecialisteComponent from '../components/SpecialisteComponent';
import ChuComponent from '../components/ChuComponent';
import HeureComponent from '../components/HeureComponent';
import SuccessComponent from '../components/SuccessComponent';
import { useNavigate, useOutletContext } from 'react-router-dom';
import CardParticular from '../components/CardParticular';
import Chu1Component from '../components/Chu1Component';
import MessageIcon from '@mui/icons-material/Message';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { grey } from '@mui/material/colors';

function Reservation() {
    const navigate = useNavigate()
    const { searchValue, clearSearch } = useOutletContext()
    const [region, setRegion] = useState(null)
    const [partie, setPartie] = useState(null)
    const [specialiste, setSpecialiste] = useState(null)
    const [chu, setChu] = useState(null)
    const [regionComponent, setRegionComponent] = useState(true)
    const [partieComponent, setPartieComponent] = useState(false)
    const [specialisteComponent, setSpecialisteComponent] = useState(false)
    const [chuComponent, setChuComponent] = useState(false)
    const [informationComponent, setInformationComponent] = useState(false)
    const [confirmationInformation, setConfirmationInformation] = useState(false)
    const [successInformation, setSuccessInformation] = useState(false)
    const [disableHours, setDisabledHours] = useState([])
    const [servicesPartie, setServicesPartie] = useState([])
    const [services, setServices] = useState([])
    const [chus, setChus] = useState([])
    const [chusServices, setChusServices] = useState([])
    const [showHours, setShowHours] = useState(false)
    const [dateRDV, setDateRDV] = useState(null)
    const [heureRDV, setHeureRDV] = useState(null)
    const [nom, setNom] = useState('')
    const [prenom, setPrenom] = useState('')
    const [age, setAge] = useState(null)
    const [genre, setGenre] = useState('M')
    const [contact, setContact] = useState('')
    const [email, setEmail] = useState('')
    const [errorData, setErrorData] = useState(false)
    const [chuNom, setChuNom] = useState('')
    const [chuCode, setChuCode] = useState('')
    const [serviceNom, setServiceNom] = useState('')
    const [reservationData, setReservationData] = useState(null)
    const [errorDateRdv, setErrorDateRdv] = useState(false)
    const [errorMessage, setErrorMessage] = useState(false)
    const [loadingPartie, setLoadingPartie] = useState(false)
    const [loadingService, setLoadingService] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [emptytChu, setEmptyChu] = useState(false)
    const [emptyService, setEmptyService] = useState(false)
    const [particularService, setParticularService] = useState([])
    const [startLimit, setStartLimit] = useState(0)
    const [endLimit, setEndLimit] = useState(6)
    useEffect(() => {
        imageMapResize();
        filterSearch()
    }, [region, searchValue]);
    const listeRegion = async () => {
        const res = []
        const q = query(collection(database, 'region'), orderBy('nom', 'asc'))
        const region_refs = await getDocs(q);
        region_refs.forEach(region => {
            res.push({
                id: region.id,
                ...region.data()
            })
        })
        return res
    }
    const listeServices = async () => {
        const res = []
        const q = query(collection(database, 'service'), orderBy('nom_service', 'asc'))
        const service_refs = await getDocs(q);
        service_refs.forEach(service => {
            res.push({
                id: service.id,
                ...service.data()
            })
        })
        return res
    }
    const listeChu = async () => {
        const res = []
        const q = query(collection(database, 'chu'), orderBy('nom_chu', 'asc'))
        const chu_refs = await getDocs(q);
        chu_refs.forEach(chu => {
            res.push({
                id: chu.id,
                ...chu.data()
            })
        })
        return res
    }
    const listChuService = async (idService) => {
        const res = []
        const q = query(collection(database, 'service_chu'), where('service_id', '==', idService), where('status', '==', true))
        const serviceChu_refs = await getDocs(q);
        const chusData = await listeChu()
        serviceChu_refs.forEach(chuData => {
            const chuFilter = chusData.filter(chuDataFilter => {
                return chuDataFilter.id == chuData.data().chu_id
            })
            var chuDoc = null
            if (chuFilter.length > 0) {
                chuDoc = chuFilter[0]
                if (chuDoc.region_id == region) {
                    res.push({
                        ...chuDoc
                    })
                }
            }
        })
        return res

    }
    const listHeureReservation = async (idService, idChu, dateReservation) => {
        const res = []
        const q = query(collection(database, 'reservation'), where('service_id', '==', idService), where('chu_id', '==', idChu), where('date_rdv', '==', dateReservation))
        const reservation_refs = await getDocs(q);
        reservation_refs.forEach(reservation => {
            res.push(reservation.data().heure_rdv)
        })
        return res

    }
    const changeRegion = async (regionName) => {
        setLoadingPartie(true)
        const regions = await listeRegion()
        const servicesData = await listeServices()
        const particularServices = servicesData.filter((data) => {
            return data.partie == 'Particulier' && data.ordre
        })
        const regionFilter = regions.filter(region => {
            return region.nom.toLowerCase() == regionName.toLowerCase()
        })
        if (regionFilter.length > 0) {
            setRegion(regionFilter[0].id)
            setRegionComponent(false)
            setPartieComponent(true)
            setParticularService(particularServices)
        }
        setLoadingPartie(false)
    }
    const changePartie = async (partieCorps) => {
        setLoadingService(true)
        setServicesPartie([])
        setServices([])
        setEmptyService(false)
        setEmptyChu(false)
        if (!successInformation) {
            setPartie(partieCorps)
            setSpecialisteComponent(true)
            setChuComponent(false)
            setInformationComponent(false)
            setConfirmationInformation(false)
            setSuccessInformation(false)
            setSpecialiste(null)
            const servicesData = await listeServices()
            const serviceFilter = servicesData.filter(service => {
                return service.partie.toLowerCase() == partieCorps.toLowerCase()
            })
            setServices(serviceFilter)
            setServicesPartie(serviceFilter)
            if (serviceFilter.length == 0) {
                setEmptyService(true)
            }
        }
        setLoadingService(false)
    }
    const changeSpecialiste = async (id, nomService) => {
        setChus([])
        setChusServices([])
        setLoadingData(true)
        setSpecialiste(id)
        setServiceNom(nomService)
        setSpecialisteComponent(false)
        setChuComponent(true)
        const chusData = await listChuService(id)
        setChus(chusData)
        setChusServices(chusData)
        clearSearch()
        setEmptyChu(false)
        if (chusData.length == 0) {
            setEmptyChu(true)
        }
        setLoadingData(false)
    }
    const changeSpecialisteParticular = async (id, nomService) => {
        setPartie('Particulier')
        setChus([])
        setChusServices([])
        setLoadingData(true)
        setSpecialiste(id)
        setServiceNom(nomService)
        setSpecialisteComponent(false)
        setChuComponent(true)
        const chusData = await listChuService(id)
        setChus(chusData)
        setChusServices(chusData)
        clearSearch()
        setEmptyChu(false)
        if (chusData.length == 0) {
            setEmptyChu(true)
        }
        setLoadingData(false)
    }
    const changeChu = (id, nomChu, codeChu) => {
        setLoadingData(true)
        setChu(id)
        setChuNom(nomChu)
        setChuCode(codeChu)
        setChuComponent(false)
        setInformationComponent(true)
        clearSearch()
        setLoadingData(false)
    }
    const changeDateRDV = async (e) => {
        const dateValue = e.target.value
        setDateRDV(null)
        setHeureRDV(null)
        setDateRDV(dateValue)
        if (comparaisonDate(dateValue)) {
            setShowHours(true)
            const listHeuresReserver = await listHeureReservation(specialiste, chu, dateValue)
            setDisabledHours(listHeuresReserver)
        }
        else {
            setErrorData(true)
            // setErrorMessage('Veuillez choisir le date valide!')
            setErrorMessage('Safidio ny daty afaran\'ny anio!')
            setShowHours(false)
            setDisabledHours([])
        }
    }
    const changeHeureRDV = (heure, status) => {
        if (!status) {
            setHeureRDV(heure)
        }
    }
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
    }
    const validationDonnees = () => {
        setLoadingData(true)
        if (nom != '' && age && genre != '' && contact != '' && dateRDV != null && heureRDV != null) {
            setInformationComponent(false)
            setConfirmationInformation(true)
            setErrorData(false)
        } else {
            setErrorData(true)
            // setErrorMessage('Veuillez remplir les champs obligatoires!')
            setErrorMessage('Fenoy daholo ireo mombamomban\'ny fanamarihana tsy maintsy tokony ho fenoina!')
        }
        setLoadingData(false)
    }
    const RectifierInfo = () => {
        setInformationComponent(true)
        setConfirmationInformation(false)
    }
    const listReservationParDate = async (idService, idChu, dateReservation) => {
        const res = []
        const q = query(collection(database, 'reservation'), where('service_id', '==', idService), where('chu_id', '==', idChu), where('date_rdv', '==', dateReservation))
        const reservation_refs = await getDocs(q);
        reservation_refs.forEach(reservation => {
            res.push({
                id: reservation.id,
                ...reservation.data()
            })
        })
        return res

    }
    const envoyer = async (e) => {
        setLoadingData(true)
        e.preventDefault()
        const reservations = await listReservationParDate(specialiste, chu, dateRDV)
        let num_reservation = 1
        if (reservations.length > 0) {
            const maxReference = reservations.reduce((max, item) => {
                const currentXxxx = parseInt(item.reference.split('/').pop());
                const maxXxxx = parseInt(max.reference.split('/').pop());
                return currentXxxx > maxXxxx ? item : max;
            }, reservations[0]);
            num_reservation = parseInt(maxReference.reference.split('/').pop()) + 1;
        }
        const num_reference = num_reservation.toString().padStart(4, '0');
        try {
            const reservation_post = await addDoc(collection(database, 'reservation'), {
                reference: `${chuCode}/${dateFormat(new Date(dateRDV), "yyyymmdd")}/${num_reference}`,
                service_id: specialiste,
                chu_id: chu,
                date_rdv: dateRDV,
                heure_rdv: heureRDV,
                nom: nom,
                prenom: prenom,
                age: age,
                genre: genre,
                email: email,
                contact: contact,
                status: false,
                lieu: 'En ligne'
            })

            const reservationDoc = doc(database, 'reservation', reservation_post.id)
            const reservationDocRef = await getDoc(reservationDoc)
            const chuDoc = doc(database, 'chu', reservationDocRef.data().chu_id)
            const serviceDoc = doc(database, 'service', reservationDocRef.data().service_id)
            const chuDocRef = await getDoc(chuDoc)
            const serviceDocRef = await getDoc(serviceDoc)
            const reservation = {
                reference: reservationDocRef.data().reference,
                service: serviceDocRef.data().nom_service,
                chu: chuDocRef.data().nom_chu,
                date: dateFormat(new Date(reservationDocRef.data().date_rdv), "dd/mm/yyyy"),
                heure_rdv: reservationDocRef.data().heure_rdv,
                nom: reservationDocRef.data().nom,
                prenom: reservationDocRef.data().prenom,
                contact: reservationDocRef.data().contact,
                contact_chu: chuDocRef.data().contact_chu,
                email_chu: chuDocRef.data().email_chu,
                lieu: chuDocRef.data().lieu,
                logo: chuDocRef.data().logo_chu,
            }
            setReservationData(reservation)
            setConfirmationInformation(false)
            setSuccessInformation(true)
            setLoadingData(false)

        } catch (err) {
            alert(err)
            setLoadingData(false)
        }

    }
    const comparaisonDate = (dateRdv) => {
        var dateNow = dateFormat(new Date(), "yyyy-mm-dd")
        var date1 = new Date(dateRdv);
        var date2 = new Date(dateNow);
        return date2 <= date1
    }
    const filterSearch = () => {
        if (specialisteComponent) {
            setStartLimit(0)
            setEndLimit(6)
            const dataServices = servicesPartie.filter(serviceData => serviceData.nom_service.toLowerCase().includes(searchValue.toLowerCase()));
            if (searchValue == '') {
                setServices(servicesPartie)
                return
            }
            setEmptyService(false)
            if (dataServices.length == 0) {
                setEmptyService(true)
            }
            setServices(dataServices)
        }
        if (chuComponent) {
            const dataChus = chusServices.filter(chuData => chuData.nom_chu.toLowerCase().includes(searchValue.toLowerCase()));
            if (searchValue == '') {
                setChus(chusServices)
                return
            }
            setEmptyChu(false)
            if (dataChus.length == 0) {
                setEmptyChu(true)
            }
            setChus(dataChus)
        }
    }
    const retour = () => {
        if (partie == '' || partie == null) {
            setPartieComponent(false)
            setRegionComponent(true)
            setRegion(null)
        }
        if (specialisteComponent) {
            setPartie(null)
            setSpecialisteComponent(false)
            setPartieComponent(true)
        }
        if (chuComponent) {
            setServiceNom('')
            setSpecialiste(null)
            setChuComponent(false)
            if (partie == 'Particulier') {
                setPartie(null)
                setSpecialisteComponent(true)
            } else setSpecialisteComponent(true)
        }
        if (informationComponent) {
            setChu(null)
            setChuNom('')
            setChuCode('')
            setInformationComponent(false)
            setChuComponent(true)
        }
        if (confirmationInformation) {
            RectifierInfo()
        }
        if (successInformation) {
            setPartieComponent(false)
            setSuccessInformation(false)
            setRegionComponent(true)
            setRegion(null)
        }
    }
    const paginationServicePrev = () => {
        const startData = startLimit -6
        const endData = endLimit - 6
        if (startData <= 0) {
            setStartLimit(0)
            setEndLimit(6)
            return
        }
        setStartLimit(startData)
        setEndLimit(endData)

    }
    const paginationServiceSuivant = () => {
        const startData = startLimit + 6
        const endData = endLimit + 6
        if (startData >= services.length) {
            setStartLimit(0)
            setEndLimit(6)
            return
        }
        setStartLimit(startData)
        setEndLimit(endData)

    }

    return (
        <div>
            {/* <Container> */}
            {regionComponent && (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} >
                        <CarteComponent onRegionClick={changeRegion} mapStyle={{ maxWidth: '100%', width: "80%", height: 'auto' }} />
                    </Grid>
                    <Grid item xs={12} sm={8} style={{ display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center" }}>
                        <Grid container spacing={2} >
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                                {loadingPartie && <CircularProgress />}
                            </Grid>
                        </Grid>
                        <Typography variant='h5' sx={{
                            textAlign: 'center', color: 'white',
                            animation: 'fadeIn 2s ease-in-out',
                            '@keyframes fadeIn': {
                                from: { opacity: 0 },
                                to: { opacity: 1 },
                            },
                        }}>
                            {/* Bienvenue à votre <b>PRISE DE RENDEZ-VOUS</b> en ligne.<br /> Nous sommes ravis de vous accueillir et espérons rendre cette expérience aussi agréable que possible. Si vous avez besoin d'aide à tout moment, n'hésitez pas à nous le faire savoir */}
                            Miarahaba Tompoko,
                            <br />
                            Tonga soa eto amin'ny sehatra <b>famandrihan-toerana</b>. Mba ahafahanay manampy anao, azafady, manindria ny faritra misy anao. Raha mila fanampiana ianao amin'ny fotoana rehetra dia aza misalasala mampahafantatra anay.
                            <br />
                            Misaotra Tompoko !
                        </Typography>
                    </Grid>
                    <Tooltip title="Fitarainana" arrow>
                        <Fab  style={{ position: "absolute", right: 0, bottom: 0, marginBottom: "10px",backgroundColor:'white', }} onClick={() => {
                            navigate('/doleance')
                        }}>
                            {/* <img src={doleanceImg} style={{ width: '50px', height: "50px" }} /> */}
                            <MessageIcon sx={{color:"#d82768"}} />
                        </Fab>
                    </Tooltip>
                </Grid>
            )}
            {partieComponent && (
                <Grid container spacing={2} style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Tooltip title="Miverina" arrow>
                        <Fab
                            size="small"
                            onClick={retour}
                            aria-label="Miverina"
                            style={{
                                position: 'absolute',
                                right: 0,
                                marginRight: '16px',
                                marginTop: '20px',
                                backgroundColor:'white',
                            }}
                        >
                            <KeyboardDoubleArrowLeftIcon sx={{color:"#d82967"}} />
                        </Fab>
                    </Tooltip>
                    <Grid item xs={12} sm={4} >
                        <PersonneComponent onCorpsClick={changePartie} personneStyle={{ maxWidth: '100%', width: "100%", height: '60%' }} />
                    </Grid>
                    <Grid item xs={12} sm={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {!partie ? (
                            <>
                                {loadingService ? (<CircularProgress />) : (
                                    <div >
                                        <Typography variant='h5' sx={{
                                            textAlign: 'center', color: 'white', mb: 1, animation: 'fadeIn 2s ease-in-out',
                                            '@keyframes fadeIn': {
                                                from: { opacity: 0 },
                                                to: { opacity: 1 },
                                            },
                                        }}>
                                            {/* Pour mieux vous assister, veuillez nous indiquer les parties de votre corps qui présentent des problèmes. Vous pouvez le faire en cliquant sur les zones concernées.<br /> Merci de votre coopération. */}
                                            Mba hanampiana anao bebe kokoa dia ampahafantaro anay hoe aiza amin'ireo faritra amin'ny vatanao no misy tsy fahatomombanana. Azonao atao izany amin'ny fikitihanao ny faritra mifandraika amin'izany.<br />
                                            Misaotra anao amin'ny fiaraha-miasa.
                                        </Typography>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, justifyContent: 'center', alignItems: 'stretch' }}>
                                            {particularService.map((data) => {
                                                return (
                                                    <CardParticular data={data} changeSpecialiste={changeSpecialisteParticular} />
                                                )
                                            })}
                                        </div>
                                    </div>

                                )}
                            </>
                        ) : (
                            <>
                                {loadingData && !confirmationInformation && (
                                    <CircularProgress />
                                )}
                                {specialisteComponent && (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'stretch' }}>
                                            {services.slice(startLimit, endLimit).map((data) => {
                                                return (
                                                    <SpecialisteComponent data={data} changeSpecialiste={changeSpecialiste} />
                                                )
                                            })}
                                            {services.length == 0 && emptyService && (
                                                <Typography variant='h5' sx={{ textAlign: 'center', color: 'white' }}>
                                                    {/* Aucune données correspondantes */}
                                                    Tsy misy valiny mifandraika amin'ny notadiavina
                                                </Typography>
                                            )}
                                        </div>
                                        {services.length > 6 && (
                                            <div style={{display:'flex',flexDirection:"row"}}>
                                                <IconButton disabled={startLimit==0} onClick={paginationServicePrev}>
                                                    <KeyboardDoubleArrowLeftIcon sx={{color:startLimit==0?grey[400]:"white"}} />
                                                </IconButton>
                                                <Typography sx={{color:"white",mt:1}} >Hijery bebe kokoa</Typography>
                                                <IconButton disabled={endLimit>=services.length} onClick={paginationServiceSuivant}>
                                                    <KeyboardDoubleArrowRightIcon sx={{color:endLimit>=services.length?grey[400]:"white"}} />
                                                </IconButton>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {chuComponent && (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'strech' }}>
                                        {chus.map((chu_choix) => {
                                            return (
                                                // <ChuComponent data={chu_choix} changeChu={changeChu} />
                                                <Chu1Component data={chu_choix} changeChu={changeChu} />
                                            )
                                        })}
                                        {chus.length == 0 && emptytChu && (
                                            <Typography variant='h5' sx={{ textAlign: 'center', color: 'white' }}>
                                                {/* Aucune données correspondantes */}
                                                Tsy misy valiny mifandraika amin'ny notadiavina
                                            </Typography>
                                        )}
                                    </div>
                                )}
                                {informationComponent && (
                                    <Card sx={{ margin: '10px', width: { sm: '70%', xs: '100%' }, height: 'auto' }} >
                                        <CardContent>
                                            <Typography sx={{ fontSize: 14, color: 'white', fontWeight: 'bold', textAlign: 'center', background: '#d82967', padding: 1, borderRadius: 5 }} color="text.secondary" gutterBottom>
                                                {/* DATE ET HEURE DE RENDEZ-VOUS */}
                                                DATY SY ORA FAMANDRIHAN-TOERANA
                                            </Typography>
                                            <span style={{ display: 'flex', justifyContent: 'space-around', padding: 2 }}>
                                                <Typography sx={{ paddingTop: 2, fontSize: 14, color: 'black', fontWeight: 'bold' }} color="text.secondary" gutterBottom>
                                                    {/* Entrez la date: */}
                                                    Safidio ny daty:
                                                </Typography>
                                                <TextField type='date' onChange={changeDateRDV} value={dateRDV} />
                                            </span>
                                            {showHours && (
                                                <>
                                                    <TableContainer component={Paper} >
                                                        <Table sx={{ minWidth: 300 }} aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>
                                                                        {/* <i>Matin</i> */}
                                                                        <i>Maraina</i>
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <HeureComponent type='matin' disabledHours={disableHours} onChangeHeure={changeHeureRDV} activeHours={heureRDV} />
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell >
                                                                        {/* <i>Après-midi</i> */}
                                                                        <i>Tolak'andro</i>
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <HeureComponent type='midi' disabledHours={disableHours} onChangeHeure={changeHeureRDV} activeHours={heureRDV} />
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <br />
                                                </>
                                            )}
                                            <Typography sx={{ fontSize: 14, color: 'white', fontWeight: 'bold', textAlign: 'center', background: '#d82967', padding: 1, borderRadius: 5 }} color="text.secondary" gutterBottom>
                                                {/* INFORMATIONS */}
                                                FAMPAHALALANA
                                            </Typography>
                                            <Box

                                                component="form"
                                                noValidate
                                                autoComplete="off">
                                                <Grid container spacing={2} sx={{ my: 2 }}>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            id="outlined-requirded"
                                                            size='small'
                                                            // label="NOM"
                                                            label="ANARANA"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(e) => {
                                                                setNom(e.target.value)
                                                            }}
                                                            value={nom}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            id="outlined-required"
                                                            size='small'
                                                            // label="PRENOM"
                                                            label="FANAMPINY"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(e) => {
                                                                setPrenom(e.target.value)
                                                            }}
                                                            value={prenom}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            required
                                                            id="outlined-number"
                                                            size='small'
                                                            type='number'
                                                            // label="AGE"
                                                            label="TAONA"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            value={age}
                                                            onChange={(e) => {
                                                                setAge(e.target.value)
                                                                if (e.target.value < 0) {
                                                                    setAge('')
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            required
                                                            id="outlined-select-currency"
                                                            select
                                                            // label="GENRE"
                                                            label="LAHY/VAVY"
                                                            defaultValue={genre}
                                                            size='small'
                                                            onChange={(e) => {
                                                                setGenre(e.target.value)
                                                            }}
                                                        >
                                                            <MenuItem value="M">
                                                                {/* Homme */}
                                                                Lahy
                                                            </MenuItem>
                                                            <MenuItem value="F">
                                                                {/* Femme */}
                                                                Vavy
                                                            </MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            id="outlined-required"
                                                            size='small'
                                                            // label="CONTACT"
                                                            label="FINDAY"
                                                            value={contact}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            type='number'
                                                            onChange={(e) => {
                                                                setContact(e.target.value)
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            id="outlined-required"
                                                            size='small'
                                                            // label="EMAIL"
                                                            label="ADRESY MAILAKA"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(e) => {
                                                                setEmail(e.target.value)
                                                            }}
                                                            value={email}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button variant="contained" color="success" onClick={validationDonnees} endIcon={<SendIcon />} >
                                                        {/* Envoyer */}
                                                        Alefa
                                                    </Button>
                                                </div>
                                            </Box>
                                        </CardContent>
                                    </Card>

                                )}
                                {confirmationInformation && (
                                    <Card sx={{ margin: '10px', width: { sm: '60%', xs: '100%' }, height: 'auto' }} >
                                        <CardContent>
                                            <Typography sx={{ fontSize: 14, color: 'white', fontWeight: 'bold', textAlign: 'center', background: '#d82967', padding: 1, borderRadius: 5 }} color="text.secondary" gutterBottom>
                                                {/* RECAPITULATION */}
                                                FAMINTINANA
                                            </Typography>
                                            <div style={{ marginLeft: '10%' }}>
                                                <Typography variant='subtitle1'><b><u>Anarana</u>: </b> {nom}</Typography>
                                                <Typography variant='subtitle1'><b><u>Fanampiny</u>: </b> {prenom}</Typography>
                                                <Typography variant='subtitle1'><b><u>Taona</u>: </b>{age} ans</Typography>
                                                <Typography variant='subtitle1'><b><u>Lahy/Vavy</u>: </b>{genre == 'F' ? 'Vavy' : 'Lahy'}</Typography>
                                                <Typography variant='subtitle1'><b><u>Finday</u>: </b>{contact}</Typography>
                                                <Typography variant='subtitle1'><b><u>Adiresy mailaka</u>: </b>{email}</Typography>
                                                <br />
                                                {/* <Typography variant='subtitle1'><b><u>Service</u>: </b>{serviceNom.toUpperCase()}</Typography> */}
                                                <Typography variant='subtitle1'><b><u>Sampan-draharaha</u>: </b>{serviceNom.toUpperCase()}</Typography>
                                                {/* <Typography variant='subtitle1'><b><u>Hopital</u>: </b>{chuNom.toUpperCase()}</Typography> */}
                                                <Typography variant='subtitle1'><b><u>Toerana</u>: </b>{chuNom.toUpperCase()}</Typography>
                                                {/* <Typography variant='subtitle1'><b><u>Date de rendez-vous</u>: </b>{dateFormat(new Date(dateRDV), "dd/mm/yyyy")} à {heureRDV}</Typography> */}
                                                <Typography variant='subtitle1'><b><u>Date nofandrihana</u>: </b>{dateFormat(new Date(dateRDV), "dd/mm/yyyy")} à {heureRDV}</Typography>
                                            </div>
                                            <br />
                                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                                <Button variant="contained" color="error" onClick={RectifierInfo}  >
                                                    {/* Annuler */}
                                                    Miverina
                                                </Button>
                                                {/* <LoadingButton loading={loadingData} loadingIndicator="Envoie…" variant="contained" color="success" onClick={envoyer}  >
                                                    Confirmer
                                                </LoadingButton> */}
                                                <LoadingButton loading={loadingData} loadingIndicator="Alefa…" variant="contained" color="success" onClick={envoyer}  >
                                                    Alefa
                                                </LoadingButton>
                                            </div>
                                        </CardContent>
                                    </Card>
                                )}
                                {successInformation && (
                                    <SuccessComponent data={reservationData} reference={reservationData.reference ? reservationData.reference : ''} />
                                )}
                            </>
                        )}
                    </Grid>
                </Grid>
            )
            }
            {/* </Container> */}
            <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert
                    onClose={handleCloseAlert}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </div >
    )
}

export default Reservation